import { signOutFunction } from "src/context/Auth/provider";
import { ValidationError } from "yup";

/** 
 * 	 Pass the errors that was catched, the setError (function to update state) and errors (state object) and then the function will update the Errors state object and return it. 
 * Or, if it's not a Yup Validation Error it returns false.
*/
export function getValidationErrors(err: any, setError: Function): boolean{
	if(err instanceof ValidationError)
	{
		err.inner.forEach((error) => {
			if(error.path)
				setError(error.path, { message: error.message});
		});
    
		return true;
	}
	return false; 
}

export const standardErrorMessages = (err: any, message: string, addToast: Function) => {
	if(err instanceof TypeError){
		addToast({
			title: "Erro",
			description: "Erro de tipo",
			color: "red",
			details: {
				header: err.message,
				text: err.stack
			}
		});
		return;
	}
	
	if(!err.response){
		addToast({
			title: "Erro",
			description: "Erro de rede",
			color: "red",
			details: {
				header: "Error ao comunicar com o servidor",
				text: "Por favor, tente novamente mais tarde"
			}
		});
		return;
	}

	if(err.response.status === 401 || (err.response.data && err.response.data.Message === "Sessão inválida")){
		signOutFunction();
		addToast({
			title: "Erro",
			description: "Não autorizado",
			color: "red",
			details: {
				header: "Você não tem acesso a este recurso ou suas credenciais de login expiraram",
				text: "Saia e faça login novamente ou se o erro persistir, entre em contato com seu administrador para ver se você tem acesso a este recurso"
			}
		});
		return;
	}

	if(err.response.data && err.response.data.Message === "Sistema em modo manutenção"){
		signOutFunction();
		addToast({
			title: "Erro",
			description: "Não autorizado",
			color: "red",
			details: {
				header: "Sistema em modo manutenção",
				text: "O sistema encontra-se em modo de manutenção"
			}
		});
		return;
	}

	if(!err.response.data){
		addToast({
			title: "Erro",
			description: "Erro de rede",
			color: "red",
			details: {
				header:  "Error ao comunicar com o servidor",
				text: "Por favor, tente novamente mais tarde"
			}
		});
		return;
	}

	addToast({
		title: "Erro",
		description: message,
		color: "red",
		details: {
			header: err.response.data.Message,
			text: err.response.data.StackTrace
		}
	});
};
